<template>
  <v-container class="mt-10">
    <h1 class="title font-weight-thin">Edit Test Step</h1>
    <span class="font-weight-bold mr-1">Release Note:</span
    ><span id="e2e-releaseNoteTitle" v-text="releaseNote.title"></span>
    <test-step-form class="mt-2" mode="edit"></test-step-form>
  </v-container>
</template>

<script>
import TestStepForm from "@/components/testStepForm";

export default {
  name: "testStepEdit",
  components: {
    TestStepForm,
  },
  computed: {
    releaseNote() {
      return this.$store.state.releaseNote.releaseNoteRecord;
    },
    releaseNoteId() {
      return parseInt(this.$route.params.releaseNoteId, 10);
    },
    testStepId() {
      return parseInt(this.$route.params.testStepId, 10);
    },
  },
};
</script>
